<script setup lang="ts">
import type { PrimitiveProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { CommandEmpty } from '#ui-kit/ui/command'

const props = defineProps<PrimitiveProps & { class?: HTMLAttributes['class'] }>()
</script>

<template>
  <CommandEmpty v-bind="props">
    <slot />
  </CommandEmpty>
</template>
